'use strict';

angular.module('upAttributes').service('ProductCategoryAttributes', [
	'FilterType',
	'DisplayType',
	function (FilterType, DisplayType) {
		return function () {
			var attributes = {
				id: {
					title: 'default.id',
					field: 'id',
					type: FilterType.Number,
					displayType: DisplayType.String,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				description: {
					title: 'default.description',
					field: 'description',
					type: FilterType.String,
					displayType: DisplayType.String,
					inputType: 'text',
					groupable: false,
					sortable: false,
					selectableColumn: true,
					filterable: false
				},
				userId: {
					title: 'default.user',
					field: 'userId',
					type: FilterType.Number,
					displayType: DisplayType.RefObject,
					filterName: 'userId',
					refParams: {
						type: 'user',
						field: 'name',
						identifyer: 'id',
						refType: 'appointment'
					},
					comparisonTypes: ['Equals', 'NotEquals'],
					inputType: 'select',
					groupable: true,
					sortable: false,
					selectableColumn: true
				},
				sortId: {
					field: 'sortId',
					type: FilterType.Number
				}
			};

			return {
				getAll: function () {
					return attributes;
				}
			};
		};
	}
]);
